import { Injectable, inject } from '@angular/core'

import { Profile } from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../tracking/tracking.service'

import { UserService } from './user.service'

declare global {
  interface Window {
    Calendly: {
      initPopupWidget(params: {
        url: string
        prefill: {
          name: string
          email: string
          customAnswers: {
            a1: string
          }
        }
      }): void
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class CalendlyService {
  private userService = inject(UserService)
  private trackingService = inject(TrackingService)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  private profile: Profile
  constructor() {
    this.userService.loadProfile().subscribe((profile) => {
      this.profile = profile
    })
  }

  public talkToCyborg(): void {
    this.trackingService.trackEvent(
      TrackingEventEnum.COMMUNITY_CALENDLY_DIALOG_OPENED,
    )
    window.Calendly.initPopupWidget({
      url: this.verityEnvironmentService.calendlyUrl,
      prefill: {
        name: this.profile.firstName + ' ' + this.profile.lastName,
        email: this.profile.email,
        customAnswers: {
          a1: this.profile.company.name,
        },
      },
    })
  }
}
